const DEFAULT_FALLBACK = 'Не удалось выполнить запрос. Попробуйте позже.';

/**
 * Преобразует результат throw/catch или errorMessages из API в строку для Ant Design message и аналога.
 */
export function normalizeApiErrorMessage(
    err: unknown,
    fallback: string = DEFAULT_FALLBACK
): string {
    if (err instanceof Error && err.message) {
        return err.message.trim() || fallback;
    }
    if (typeof err === 'string') {
        return err.trim() || fallback;
    }
    if (Array.isArray(err)) {
        const parts = err
            .filter((x) => x != null && x !== '')
            .map((x) => {
                if (typeof x === 'string') return x;
                if (x instanceof Error) return x.message;
                return String(x);
            })
            .filter(Boolean);
        return parts.length ? parts.join('. ') : fallback;
    }
    return fallback;
}

/** Список строк для нескольких уведомлений (или одна строка как массив). */
export function normalizeApiErrorStrings(err: unknown, fallback?: string): string[] {
    if (
        Array.isArray(err) &&
        err.every((item) => typeof item === 'string' || typeof item === 'number')
    ) {
        const strings = err.map(String).filter(Boolean);
        return strings.length ? strings : [normalizeApiErrorMessage(err, fallback)];
    }
    return [normalizeApiErrorMessage(err, fallback)];
}
